module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/story-detail/story-detail.component.css
// module id = ./src/app/story-detail/story-detail.component.css
// module chunks = main